import { useSkillById } from "@/api/skills";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";
import { SkillPane } from "@/panes/skill/SkillPane";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export const SkillsViewPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  // Fetch skill for document title
  const { data: skill } = useSkillById(id || "");
  const skillName = skill?.name || "Skill";

  if (!id) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <div className="text-muted-foreground">Skill ID not found</div>
        <Button variant="outline" onClick={() => navigate(ROUTES.SKILLS.ROOT)}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Skills
        </Button>
      </div>
    );
  }

  return (
    <>
      <title>{skillName}</title>
      <div className="h-screen flex flex-col">
        {/* Full-screen skill pane */}
        <div className="flex-1 overflow-hidden">
          <SkillPane />
        </div>
      </div>
    </>
  );
};
